export const CONFIRM_EMAIL = 'AUTH/CONFIRM_EMAIL';
export const CONFIRM_EMAIL_PENDING = `${CONFIRM_EMAIL}_PENDING`;
export const CONFIRM_EMAIL_FULFILLED = `${CONFIRM_EMAIL}_FULFILLED`;
export const CONFIRM_EMAIL_REJECTED = `${CONFIRM_EMAIL}_REJECTED`;

export const confirmEmail = () => ({
  type: CONFIRM_EMAIL,
});
